import React from "react";
import Carousel from "react-bootstrap/Carousel";
import { useNavigate } from "react-router-dom";

const LandingPageComponent = () => {
    const navigate = useNavigate();

    const handleGetStarted = () => {
        navigate("/reviews"); // Navigate to the ReviewsComponent
    };

    return (
        <div className="landingContainer">
                <div className="landingPageContainer">
                <header className="landingHeader">
                    <h1 className="landingTitle">Welcome to AppStats</h1>
                    <p className="landingSubtitle">Effortless App Sentiment Analysis</p>
                </header>
                <Carousel className="landingCarousel">
                    <Carousel.Item>
                        <div className="carouselCard">
                            <h3>Multiple Storefronts</h3>
                            <img src='./img/globe.png' alt="Multiple Storefronts" className="carouselImage" />
                            <p>Track reviews from multiple storefronts in one place.</p>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="carouselCard">
                            <h3>Filter Reviews</h3>
                            <img src='./img/headphones.png' alt="Multiple Storefronts" className="carouselImage" />
                            <p>Filter through large volumes of reviews effortlessly.</p>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="carouselCard">
                            <h3>Visualize Feedback</h3>
                            <img src='./img/pie_chart.png' alt="Multiple Storefronts" className="carouselImage" />
                            <p>Visualize feedback performance over multiple versions.</p>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="carouselCard">
                            <h3>Competitor Analysis</h3>
                            <img src='./img/eye.png' alt="Multiple Storefronts" className="carouselImage" />
                            <p>Learn from their mistakes so you don't have to make them.</p>
                        </div>
                    </Carousel.Item>
                </Carousel>
                <button className="getStartedButton" onClick={handleGetStarted}>
                    Get Started
                </button>
                <div className="licenseLink">
                By using this site you agree to&nbsp;
                    <a href="/license" className="terms-link">
                        Terms of Use
                    </a>
                </div>
            </div>
        </div>
        
    );
};

export default LandingPageComponent;